/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tag-text-outline': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M21.4 11.6l-9-9C12 2.2 11.5 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .5.2 1 .6 1.4l9 9c.4.4.9.6 1.4.6.5 0 1-.2 1.4-.6l7-7c.4-.4.6-.9.6-1.4 0-.5-.2-1-.6-1.4M13 20l-9-9V4h7l9 9M6.5 5C7.3 5 8 5.7 8 6.5S7.3 8 6.5 8 5 7.3 5 6.5 5.7 5 6.5 5m3.6 3.9l1.4-1.4L17 13l-1.4 1.4-5.5-5.5m-2.5 2.5L9 10l4 4-1.4 1.4-4-4z"/>'
  }
})
